import React from "react";

/**
 * Unified profile avatar used across all headers.
 *
 * Pre-login:  renders the profile silhouette SVG (lime circle).
 * Post-login: renders the first letter of the user's display name
 *             inside a lime circle.
 *
 * @param {{ displayName?: string, email?: string } | null} user
 * @param {() => void} onClick
 * @param {string} [className]
 */
export default function ProfileAvatar({ user, onClick, className = "" }) {
  if (!user) {
    return (
      <button
        onClick={onClick}
        className={`w-9 h-9 rounded-full flex-shrink-0 cursor-pointer ${className}`}
        aria-label="Login"
      >
        <img
          src="/images/profile_colored.svg"
          alt="Login"
          className="w-full h-full"
        />
      </button>
    );
  }

  const firstLetter = user.displayName?.[0]?.toUpperCase()
    || user.email?.[0]?.toUpperCase()
    || "?";

  return (
    <button
      onClick={onClick}
      className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-black cursor-pointer transition-all ${className}`}
      style={{ background: "#c8f135", color: "#000" }}
      aria-label="User menu"
    >
      {firstLetter}
    </button>
  );
}
